import { Button, Tooltip } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import React from 'react';
import { ButtonProps } from 'antd/es/button/button';
import { SendEmailEnum, useInviteUser } from '../../../../../hooks/api/inviteUsers';
import { useSimpleModal } from '../../../../Common/Modal/Simple';
import { useMessageError, useMessageSuccess } from '../../../../../hooks/common';

interface ActionButtonProps<RequestRes = undefined> {
  contractNumber: string; // Partial<UserTableRow>
  userId: string;
  buttonProps?: ButtonProps;
  setTableKey?: (newVal: number) => void;
  afterSuccess?: (res?: RequestRes) => void;
}

export default function SendWelcomeMailBtn({ contractNumber, userId, buttonProps }: ActionButtonProps) {
  const inviteUser = useInviteUser();
  const { open, contextHolder } = useSimpleModal();

  useMessageError([inviteUser]);
  useMessageSuccess([inviteUser], 'E-mail sent successfully');

  if (!contractNumber) {
    return null;
  }

  return (
    <>
      <Tooltip title="Send Welcome E-Mail" placement="topRight">
        <Button
          key="changeStatus"
          type="dashed"
          icon={<SendOutlined />}
          loading={inviteUser.loading}
          title="Invite user"
          onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();

            open({
              icon: <SendOutlined />,
              title: 'Invite user?',
              content: (
                <span>
                  Are you sure you want to send Welcome E-Mail to contract
                  {' '}
                  <b>{contractNumber}</b>
                  ?
                </span>
              ),
              cancelText: 'Cancel',
              okText: 'Send E-Mail',
              onOk: () => {
                const payload = { type: SendEmailEnum.WELCOME_EMAIL, contractNumber, userId };
                // const searchParams = createSearchParamsString(payload);

                inviteUser.fetch(payload);
              },
            });
          }}
          {...buttonProps}
        >
          Send Welcome E-mail
        </Button>
      </Tooltip>
      {contextHolder}
    </>
  );
}
